/**
 *
 * @module accountClientConfiguration
 *
 */

import ServiceClientConfiguration from './../configuration/serviceClientConfiguration';

/**
 *
 * @class AccountClientConfiguration
 * @extends ServiceClientConfiguration
 * @desc Provides configuration information used by the AccountClient.
 *
 */
export default class AccountClientConfiguration extends ServiceClientConfiguration {}



// WEBPACK FOOTER //
// ./src/services/account/accountClientConfiguration.js